export const KONWLEDGE_BASE_URL = {
  AMAZON_UAM_TAM: 'https://knowledge-base.yieldbird.com/prebid-stack/amazon-uamtam',
} as const
